import type { ReactNode } from 'react'

import { useAppRouter } from '@/shared/lib/router'
import { LandingHeader } from '@/shared/ui/LandingHeader'
import { LandingFooter } from '@/shared/ui/LandingFooter'

interface LegalPageShellProps {
  children: ReactNode
}

export function LegalPageShell({ children }: LegalPageShellProps) {
  const router = useAppRouter()

  return (
    <div className="min-h-screen">
      <LandingHeader
        onSignIn={() => router.push('/?modal=sign-in')}
        onSignUp={() => router.push('/?modal=sign-up')}
      />

      <main className="pt-20">{children}</main>

      <LandingFooter />
    </div>
  )
}
